import React from 'react';
import { useTranslation } from 'react-i18next';
import { SvgIcon, useMediaQuery, usePagination, useTheme } from '@kis-technologies/kis-ui';
import { PaginationProps } from '../types';
import { PaginationButton, PaginationIconContainer, ButtonContent, EllipsisContent, useStyles } from '../styled';

export const BasicPagination = (props: PaginationProps) => {
  const classes = useStyles();
  const themes = useTheme();
  const matchPortrait = useMediaQuery(themes.breakpoints.down('lg'));
  const { items } = usePagination({
    page: props.page,
    count: props.pages,
    boundaryCount: 1,
    siblingCount: matchPortrait ? 0 : 2
  });
  const { t } = useTranslation();

  return (
    <nav className={classes.nav}>
      <ul className={classes.ul}>
        {items.map(({ page, type, selected, ...item }, index) => {
          let children = null;
          if (type === 'start-ellipsis' || type === 'end-ellipsis') {
            children = <EllipsisContent>...</EllipsisContent>;
          } else if (type === 'previous') {
            children = (
              <PaginationButton
                corner
                disabled={props.page === 1}
                onClick={() => {
                  props.onPageChange(props.page - 1);
                }}
                data-testid="pagination-prev"
                aria-label="pagination-previous-button"
              >
                <PaginationIconContainer>
                  <SvgIcon name="chevron_left" />
                </PaginationIconContainer>
                <ButtonContent>{t('commonText.previous')}</ButtonContent>
              </PaginationButton>
            );
          } else if (type === 'next') {
            children = (
              <PaginationButton
                corner
                disabled={props.page === props.pages}
                onClick={() => {
                  props.onPageChange(props.page + 1);
                }}
                data-testid="pagination-next"
                aria-label="pagination-next-button"
              >
                <ButtonContent>{t('commonText.more')}</ButtonContent>
                <PaginationIconContainer>
                  <SvgIcon name="chevron_right" />
                </PaginationIconContainer>
              </PaginationButton>
            );
          } else if (type === 'page') {
            children = (
              <PaginationButton
                key={page}
                disabled={props.page === page}
                onClick={() => {
                  if (page !== null) {
                    props.onPageChange(page);
                  }
                }}
              >
                {page}
              </PaginationButton>
            );
          } else {
            children = (
              <button type="button" {...item}>
                {type}
              </button>
            );
          }

          return (
            <li key={index} className={classes.li} onClick={item.onClick}>
              {children}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
